export const data = [
  {
    name: 'Задать вопрос',
    id: '1',
    sid: 'ask_question',
    submitButton: 'Отправить вопрос',
    steps: [
      {
        title: 'Оставьте Ваши контакты, мы обязательно свяжемся с Вами в течение рабочего дня.',
        fields: [
          {
            caption: 'ФИО',
            required: false,
            structure: [
              {
                name: 'form_text_1',
                type: 'text',
                valueDefault: ' ',
                active: true
              }
            ]
          },
          {
            caption: 'Ваш E-mail',
            required: false,
            structure: [
              {
                name: 'form_text_2',
                type: 'email',
                valueDefault: ' ',
                active: true
              }
            ]
          },
          {
            caption: 'Ваш вопрос',
            required: false,
            structure: [
              {
                name: 'form_textarea_3',
                type: 'textarea',
                valueDefault: ' ',
                active: true
              }
            ]
          }
        ]
      }
    ]
  },
  {
    name: 'Запрос коммерческого предложения',
    id: '2',
    sid: 'offer_request',
    submitButton: 'Сохранить',
    steps: [
      {
        title: 'Оставьте Ваши контакты, мы обязательно свяжемся с Вами в течение рабочего дня.',
        fields: [
          {
            caption: 'ФИО',
            required: false,
            structure: [
              {
                name: 'form_text_4',
                type: 'text',
                valueDefault: ' ',
                active: true
              }
            ]
          },
          {
            caption: 'Компания',
            required: false,
            structure: [
              {
                name: 'form_text_7',
                type: 'text',
                valueDefault: ' ',
                active: true
              }
            ]
          },
          {
            caption: 'Город',
            required: false,
            structure: [
              {
                name: 'form_text_8',
                type: 'text',
                valueDefault: ' ',
                active: true
              }
            ]
          },
          {
            caption: 'Ваш E-mail',
            required: false,
            structure: [
              {
                name: 'form_text_5',
                type: 'email',
                valueDefault: ' ',
                active: true
              }
            ]
          },
          {
            caption: 'Ваш телефон',
            required: false,
            structure: [
              {
                name: 'form_text_6',
                type: 'phone',
                valueDefault: ' ',
                active: true
              }
            ]
          }
        ]
      },
      {
        title: 'Выберите интересующее вас оборудование ',
        fields: [
          {
            caption: 'Какое оборудование Вас интересует?',
            required: false,
            structure: [
              {
                id: '11',
                multiple: true,
                name: 'form_multiselect_equipment[]',
                type: 'multiselect',
                valueDefault: '11',
                text: 'Insitec',
                active: true
              },
              {
                id: '13',
                multiple: true,
                name: 'form_multiselect_equipment[]',
                type: 'multiselect',
                valueDefault: '13',
                text: 'Mastersizer',
                active: true
              },
              {
                id: '14',
                multiple: true,
                name: 'form_multiselect_equipment[]',
                type: 'multiselect',
                valueDefault: '14',
                text: 'Microcal',
                active: true
              },
              {
                id: '15',
                multiple: true,
                name: 'form_multiselect_equipment[]',
                type: 'multiselect',
                valueDefault: '15',
                text: 'Morphologi',
                active: true
              },
              {
                id: '16',
                multiple: true,
                name: 'form_multiselect_equipment[]',
                type: 'multiselect',
                valueDefault: '16',
                text: 'NanoSight',
                active: true
              },
              {
                id: '17',
                multiple: true,
                name: 'form_multiselect_equipment[]',
                type: 'multiselect',
                valueDefault: '17',
                text: 'Omnisec',
                active: true
              },
              {
                id: '19',
                multiple: true,
                name: 'form_multiselect_equipment[]',
                type: 'multiselect',
                valueDefault: '19',
                text: 'Parsum',
                active: true
              },
              {
                id: '21',
                multiple: true,
                name: 'form_multiselect_equipment[]',
                type: 'multiselect',
                valueDefault: '21',
                text: 'Spraytec',
                active: true
              },
              {
                id: '25',
                multiple: true,
                name: 'form_multiselect_equipment[]',
                type: 'multiselect',
                valueDefault: '25',
                text: 'Zetasizer',
                active: true
              }
            ]
          }
        ]
      },
      {
        title: 'Укажите дополнтельную информацию',
        fields: [
          {
            caption: 'Если Вам есть что добавить, заполните поле ниже, пожалуйста.',
            required: false,
            structure: [
              {
                name: 'form_textarea_26',
                type: 'textarea',
                valueDefault: ' ',
                active: true
              }
            ]
          }
        ]
      }
    ]
  },
  {
    name: 'Запрос демонстрации',
    id: '3',
    sid: 'demo_dmc_kdco',
    submitButton: 'Отправить',
    steps: [
      {
        title: 'Выберите место проведения демонстрации',
        fields: [
          {
            caption: 'Тип',
            required: false,
            structure: [
              {
                name: 'form_hidden_27',
                type: 'demo',
                valueDefault: 'ДМЦ "КДСО"',
                active: true,
                WEB_FORM_ID: 3
              },
              {
                name: 'form_hidden_40',
                type: 'demo',
                valueDefault: 'Выездная демонстрация',
                active: true,
                WEB_FORM_ID: 4,
              }
            ]
          }
        ]
      },
      {
        title: 'Выберите оборудование для демонстрации',
        fields: [
          {
            caption: 'Выберите, пожалуйста, оборудование для демонстрации:',
            required: false,
            structure: [
              {
                id: '28',
                multiple: true,
                name: 'form_multiselect_equipment[]',
                type: 'multiselect',
                valueDefault: '28',
                text: 'Insitec',
                active: true
              },
              {
                id: '29',
                multiple: true,
                name: 'form_multiselect_equipment[]',
                type: 'multiselect',
                valueDefault: '29',
                text: 'Mastersizer',
                active: true
              },
              {
                id: '30',
                multiple: true,
                name: 'form_multiselect_equipment[]',
                type: 'multiselect',
                valueDefault: '30',
                text: 'Morphologi',
                active: true
              },
              {
                id: '31',
                multiple: true,
                name: 'form_multiselect_equipment[]',
                type: 'multiselect',
                valueDefault: '31',
                text: 'NanoSight',
                active: true
              },
              {
                id: '32',
                multiple: true,
                name: 'form_multiselect_equipment[]',
                type: 'multiselect',
                valueDefault: '32',
                text: 'Zetasizer',
                active: true
              }
            ]
          }
        ]
      },
      {
        title: 'Оставьте Ваши контакты, мы обязательно свяжемся с Вами в течение рабочего дня.',
        fields: [
          {
            caption: 'ФИО',
            required: false,
            structure: [
              {
                name: 'form_text_33',
                type: 'text',
                valueDefault: ' ',
                active: true
              }
            ]
          },
          {
            caption: 'Компания',
            required: false,
            structure: [
              {
                name: 'form_text_36',
                type: 'text',
                valueDefault: ' ',
                active: true
              }
            ]
          },
          {
            caption: 'Город',
            required: false,
            structure: [
              {
                name: 'form_text_37',
                type: 'text',
                valueDefault: ' ',
                active: true
              }
            ]
          },
          {
            caption: 'Адрес для организации демонстрации',
            required: false,
            structure: [
              {
                name: 'form_text_38',
                type: 'text',
                valueDefault: ' ',
                active: true,
                if: 3
              }
            ]
          },
          {
            caption: 'Ваш E-mail',
            required: false,
            structure: [
              {
                name: 'form_text_34',
                type: 'email',
                valueDefault: ' ',
                active: true
              }
            ]
          },
          {
            caption: 'Ваш номер телефона',
            required: false,
            structure: [
              {
                name: 'form_text_35',
                type: 'phone',
                valueDefault: ' ',
                active: true
              }
            ]
          }
        ]
      },
      {
        title: 'Укажите дополнтельную информацию',
        fields: [
          {
            caption: 'Напишите нам в поле ниже, если Вам есть что добавить',
            required: false,
            structure: [
              {
                name: 'form_textarea_39',
                type: 'textarea',
                valueDefault: ' ',
                active: true
              }
            ]
          }
        ]
      }
    ]
  },
  {
    name: 'Заказать звонок',
    id: '5',
    sid: 'call',
    submitButton: 'Запросить обратный звонок',
    steps: [
      {
        title: 'Оставьте Ваши контакты, мы обязательно свяжемся с Вами в течение рабочего дня.',
        fields: [
          {
            caption: 'Как Вас зовут?',
            required: false,
            structure: [
              {
                name: 'form_text_52',
                type: 'text',
                valueDefault: ' ',
                active: true
              }
            ]
          },

          {
            caption: 'Какую компанию Вы представляете?',
            required: false,
            structure: [
              {
                name: 'form_text_53',
                type: 'text',
                valueDefault: ' ',
                active: true
              }
            ]
          },
          {
            caption: 'Ваш номер телефона',
            required: false,
            structure: [
              {
                name: 'form_text_54',
                type: 'phone',
                valueDefault: ' ',
                active: true
              }
            ]
          }
        ]
      }
    ]
  }
]
